import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-market",
  "use": "icon-market-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-market\"><defs><style type=\"text/css\"></style></defs><path d=\"M67.831 419.824l54.218 462.231h779.192l54.218-462.231H67.831zM643.117 680.87H371.379v-66.388h271.738v66.388zM308.896 273.885h401.088v73.025H308.896z\" p-id=\"5849\" /><path d=\"M742.676 210.06l42.776 164.474h76.45l-54.22-230.82h-600.87l-54.22 230.82h76.45l42.776-164.475z\" p-id=\"5850\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol